import { Service } from '../Service';
export default class RemtoeControlService extends Service {
    constructor(axios) {
        super(axios);
    }
}
